import React from 'react';
import CartContacts from '../cells/Contacts/Contacts';
import CartOrder from '../cells/Order/Order';
import CartPaymentForm from '../cells/PaymentGT/Payment';
import CartDelivery from '../cells/Delivery/Delivery';

const CartSwitcher = (props) => {
    const { elemForm, storeFormData } = props;
    const group = elemForm.group;
    const config = {
        ...props,
        id: elemForm.id,
        title: elemForm.title,
        storeFormData
    };
    switch (group) {
        case 'contacts':
            return <CartContacts {...config} />;
        case 'order':
            return <CartOrder {...config} />;
        case 'delivery':
            return <CartDelivery {...config} />;
        case 'payment':
            return <CartPaymentForm {...config} />;
        default:
            return <div />;
    }
};
export default CartSwitcher;
